import {Component, EventEmitter, Input, Output} from '@angular/core';
import {WidgetSize} from '../../../../../../domain/widget/model/widget-size.enum';

@Component({
  selector: 'app-widget-message',
  templateUrl: './home-dashboard-widget-message.component.html'
})
export class HomeDashboardWidgetMessageComponent {
  readonly widgetsSize = WidgetSize;

  @Input() widgetLabel: string | undefined;
  @Input() widgetSize: string | undefined;
  @Input() icone: string | undefined;
  @Input() message: string | undefined;
  @Input() callToActionButtonLabel: string | undefined;
  @Input() callToActionHref: string | undefined;

  @Input() actionLabel: string | undefined;
  @Output() actionEvent = new EventEmitter<string>();
}
